import { createReduxAsyncAction } from '../utils/toolkit';
import { TYPES } from './constants';

export const loadYards = createReduxAsyncAction(TYPES.LOAD_YARDS);
export const createYard = createReduxAsyncAction(TYPES.CREATE_YARD);
export const loadYard = createReduxAsyncAction(TYPES.LOAD_YARD);
export const saveYard = createReduxAsyncAction(TYPES.SAVE_YARD);
export const deleteYard = createReduxAsyncAction(TYPES.DELETE_YARD);
